module.exports = __webpack_public_path__ + "img/w_facebook.06e8d1e4.svg";